import axios from 'axios'
import library from '../../../utils/Library'

export const createSubscriberRegistrationUserInvite = async (newInvite) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('invite_api') +
    '/createSubscriberRegistrationUserInvite'

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: newInvite
  })
}
